import config from "config/config";
import getTokens from "api/getTokens";

const { baseUrl, clientUrl } = config;

export default async function getPhishings(page = 1) {
  const endpoint = `${baseUrl}/v1/darkweb/phishings?page=${page}`;

  let access = "";
  const tokens = getTokens();

  if (tokens && tokens.access && tokens.access.token) {
    access = tokens.access.token;
  } else {
    window.location.href = "/login";
    return;
  }

  const options = {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": `${clientUrl || ""}`,
      "Access-Control-Allow-Credentials": true,
      Authorization: `bearer ${access}`,
    },
  };

  return fetch(endpoint, options)
    .then((response) => {
      if (![200, 201, 204].includes(response.status)) {
        throw new Error("Errore nella risposta");
      }
      return response.json();
    })
    .catch((e) => {
      console.log("error", e);
    });
}
